import { InstructionType } from './instructions'

export const chooseOneInstructionTypeKeys = new Set<InstructionType>([
  InstructionType.ORGANIZATION,
  InstructionType.BILLING_PRIMARY,
])